import type { Root, RootContent } from "mdast";
import type { LeafDirective } from "mdast-util-directive";

export type TaskBodySegment = {
    /** 0-based; also the filename stem used for the derived storage path. */
    index: number;
    /** Root-level mdast nodes belonging to this segment, in document order. */
    nodes: RootContent[];
};

export function isTextareaDirectiveNode(node: RootContent): node is LeafDirective {
    return node.type === "leafDirective" && (node as LeafDirective).name === "textarea";
}

/**
 * Splits a task body's mdast tree into segments: everything from the start
 * of the doc (or the end of the previous ::textarea) up to and including the
 * next ::textarea. Trailing content after the last ::textarea becomes its
 * own final segment. Only root-level siblings are considered — a ::textarea
 * nested inside a container directive (e.g. ::dropdown) is not a boundary.
 */
export function segmentTaskBody(tree: Root): TaskBodySegment[] {
    const segments: TaskBodySegment[] = [];
    let current: RootContent[] = [];

    for (const node of tree.children) {
        current.push(node);
        if (isTextareaDirectiveNode(node)) {
            segments.push({ index: segments.length, nodes: current });
            current = [];
        }
    }
    if (current.length > 0) segments.push({ index: segments.length, nodes: current });

    return segments;
}
